/**
 * 根据关键字过滤行政区划树
 * @param {Array} tree 原始树结构
 * @param {String} keyword 搜索关键字（不区分大小写）
 * @returns {Array} 过滤后的新树
 */

export function filterTreeByKeyword(tree = [], keyword ='') {
  if (!keyword.trim()) return tree; //空关键字返回原树

  const kw = keyword.trim().toLowerCase();

  return tree
    .map(node => {
      const clone = { ...node };

      const isDistrict = clone.deptType === 2 ;
      const nameHit = clone.deptName.toLowerCase().includes(kw);

      if (isDistrict && nameHit) {
        return clone;
      }

      if (isDistrict) {
        clone.children = filterTreeByKeyword(clone.children || [],keyword);
        return (clone.children || []).length ? clone : null;
      }

      if (nameHit) return clone;

      clone.children = filterTreeByKeyword(clone.children || [],keyword);
      return (clone.children || []).length ? clone : null;
    })
    .filter(Boolean);
}
